import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
}

/** Small mono label above a section heading. Inherits the text color. */
export const Eyebrow: FC<EyebrowProps> = ({ children, className }): ReactNode => {
    return (
        <p className={cn('flex items-center gap-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.24em] opacity-80', className)}>
            <span aria-hidden='true' className='size-2 rounded-full bg-current' />
            {children}
        </p>
    )
}
